/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/prefer-default-export */

import { FmdGood, NearMe } from "@mui/icons-material";
import { Icon, Tooltip } from "@mui/material";
import lod_ from "lodash";

const ColorItemLabel = ({ color }) => {
	return (
		<div
			style={{
				height: "3vh",
				width: "3vh",
				borderRadius: "7px",
				backgroundColor: color
			}}
		></div>
	);
};

const createObjectTable = (obj, cell, dictionary, form) => {
	if (!lod_.isArray(obj)) {
		obj = [obj];
	}

	let collection = form?.collectionDefault;
	let attribute = cell?.column?.id;

	if (!collection || !attribute) return null;

	let midPath = collection + "." + attribute;

	let sample = obj[0];
	let sampleKeys = Object.keys(sample);

	return (
		<table>
			<thead>
				<tr>
					{sampleKeys.map((key, index) => {
						let realPath = midPath + "." + key;
						realPath = realPath.split(".")?.join(".items.");
						let fromDictionary = lod_.get(dictionary, realPath);
						if (fromDictionary) {
							return <th key={index}>{fromDictionary.label.fr}</th>;
						} else {
							return null;
						}
					})}
				</tr>
			</thead>
			<tbody>
				{obj.map((row, index) => {
					return (
						<tr key={index}>
							{sampleKeys.map((key, index) => {
								return <td key={index}>{row[key]}</td>;
							})}
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};

const createArrayTable = arr => {
	return <div>{arr.join(", ")}</div>;
};

/**
 * ##############################
 * Display special fields in table
 * e.g : colors, icons, images, etc
 * ##############################
 */
export function handleSpecialCell(cell, rowKey, dictionary, form, chart) {
	let dictionaryPath = chart?.request?.collection + "." + cell.column.id;
	dictionaryPath = dictionaryPath.replaceAll(".", ".items.");
	let dictionaryItem = lod_.get(dictionary, dictionaryPath);

	const TYPE_DATE = ["date", "datetime"];
	const TYPE_DURATION = ["timestamp"];

	let filtersLabel = [];
	switch (cell.column.id) {
		case "filters":
			(cell.value ?? []).map((filter, index) => {
				if (filter.source === "special") {
					filtersLabel.push(filter.label);
				}
				let realPath = filter.dictionaryPath?.split(".")?.join(".items.");
				let fromDictionary = lod_.get(dictionary, realPath);
				if (fromDictionary && fromDictionary.analytics && fromDictionary.active) {
					filtersLabel.push(fromDictionary.label.fr);
				}
			});
			return <div>{filtersLabel.join(" / ")}</div>;
		case "color":
			return <ColorItemLabel color={cell.value} />;
		case "display.pages":
			return <div>{(cell.value ?? []).join(", ")}</div>;
		case "images":
			if (!cell.value) return null;
			return <div>voir (bientot dispo)</div>;
		case "active":
		case "analysed":
			if (!cell.value) {
				return (
					<Icon color="error" fontSize="medium">
						close
					</Icon>
				);
			} else {
				return (
					<Icon color="success" fontSize="medium">
						check
					</Icon>
				);
			}
		default:
			/**
			 * Dictionary case handling
			 */
			if (dictionaryItem && TYPE_DATE.includes(dictionaryItem.type)) {
				return <span>{new Date(cell.value).toLocaleString("FR-fr")}</span>;
			}
			/**
			 * Default case handling
			 */
			if (lod_.isArray(cell.value)) {
				let sample = cell.value[0];

				if (lod_.isObject(sample)) {
					return createObjectTable(cell.value, cell, dictionary, form);
				} else {
					return createArrayTable(cell.value);
				}
			} else if (lod_.isObject(cell.value)) {
				return createObjectTable(cell.value, cell, dictionary, form);
			} else {
				return cell.render("Cell");
			}
	}
}
